import { useMemo } from 'react';

import { CraftsmanPropertyHeader } from '../../../components/CraftsmanPropertyHeader/CraftsmanPropertyHeader.tsx';
import { Header } from '../ColumnSections/Header.tsx';
import { EDIT_MODE_OFF } from '../consts.ts';

export const useHeaderByID = (
  handleObjectiveEditModeToggle: (id: string) => void,
  objectiveEditMode: string,
) =>
  useMemo(
    () =>
      ({ id }: { id: string }) => (
        <>
          <CraftsmanPropertyHeader propertyId={id} />
          <Header
            id={id}
            onModeToggle={() => handleObjectiveEditModeToggle(id)}
            editMode={objectiveEditMode === id ? 'objective' : 'subjective'}
            disableEdit={objectiveEditMode !== EDIT_MODE_OFF}
          />
        </>
      ),
    [handleObjectiveEditModeToggle, objectiveEditMode],
  );
